import { render } from "./_form-role-select.vue?vue&type=template&id=2d83549d&lang=pug"
import script from "./_form-role-select.vue?vue&type=script&lang=js"
export * from "./_form-role-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__